/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjMzMzM0IDE1VjFIMTMuNjY2N1YxMC44TDkuNDY2NjggMTVIMi4zMzMzNFpNMTMgMS42NjY2N0gzLjAwMDAxVjE0LjMzMzNIOS4wMDAwMVYxMC4zMzMzSDEzVjEuNjY2NjdaTTQuNjY2NjggMy42NjY2N0gxMS4zMzMzVjQuMzMzMzNINC42NjY2OFYzLjY2NjY3Wk0xMS4zMzMzIDYuNjY2NjdINC42NjY2OFY3LjMzMzMzSDExLjMzMzNWNi42NjY2N1pNNC42NjY2OCA5LjY2NjY3SDYuNjY2NjhWMTAuMzMzM0g0LjY2NjY4VjkuNjY2NjdaIiBmaWxsPSJpbmhlcml0Ii8+";